import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'

export const Row = styled.div`
  margin: 26px 0 30px;
`

export const Cell = styled.div`
  vertical-align: top;
  width: 18em;
  ${Mixin.responsive('display', 'table-cell', 'block')}
  ${Media.mobile`
    & + & {
      margin-top: 7px;
    }
  `}
  ${Media.desktop`
    & + & {
      width: 18em;
      padding-left: 24px;
      vertical-align: middle;
    }
  `}
`
